(ns frontend.ui.component.heading.style
  (:require
   [frontend.ui.style.theme.core :refer [edge-size font-weight text-size font-families]]
   [garden.util :refer [space-join]]))

(defn h1
  []
  {:margin      (space-join [0 0 (edge-size :small)])
   :font-weight (font-weight :bold)
   :font-family (font-families :primary)
   :font-size   (text-size :large :size)})

(defn h2
  []
  {:margin      (space-join [0 0 (edge-size :small)])
   :font-weight (font-weight :bold)
   :font-size   (text-size :small :size)})

(defn h3
  []
  {:margin      0
   :font-weight (font-weight :bold)
   :font-size   (text-size :small :size)})

(defn h4
  []
  {})

(defn h5
  []
  {})

(defn h6
  []
  {})
